const base = process.env.VUE_APP_ESJ_URL
console.log(process.env)
const esjAPI = {

    QwEquipmentindex: base + 'QwEquipment/index', //设备查询

}
module.exports = {
    esjAPI: esjAPI,
}


// WEBPACK FOOTER //
// ./src/api/usedexcavator.js